import { ContactResult, ContactResultType } from "../../../../dtos/ContactResult";

/** A contact result for medical non-candidacy. */
class MedicalNonCanContactResult extends ContactResult {
  /**
   * @param patientId - The ID of the patient for whom the contact result is being created.
   * @param leadId - The ID of the lead associated with the contact result.
   * @param disqualifyingReasonId - The ID of the disqualifying reason for medical non-candidacy.
   */
  constructor(patientId: string, leadId: string, disqualifyingReasonId: string) {
    super(patientId, leadId, ContactResultType.ObxNonCandidateMedical, undefined);
    this.disqualifyingReasons = { ...this.disqualifyingReasons, [disqualifyingReasonId]: true };
  }
}

export default MedicalNonCanContactResult;
